export const isUnsplashImage = function (url) {
    return /images\.unsplash\.com/.test(url);
};
//# sourceMappingURL=is-unsplash-image.js.map